// extracted by mini-css-extract-plugin
module.exports = {"main":"Psypage_main__2nC1q","container":"Psypage_container__3cgHd","one":"Psypage_one__2u042","two":"Psypage_two__1pzOr","title":"Psypage_title__81Gdp"};